import { Show } from 'solid-js';
import { FiRefreshCw } from 'solid-icons/fi';
import { config } from '@config/env';

interface LivePerformancePollStatusProps {
  active: () => boolean;
  connected: () => boolean;
}

/**
 * Lower-left indicator while Live Performance fetches new events_aggregate rows.
 * Respects VITE_ENABLE_WEBSOCKETS / ENABLE_WEBSOCKETS via config.ENABLE_WEBSOCKETS.
 */
export default function LivePerformancePollStatus(props: LivePerformancePollStatusProps) {
  const websocketsEnabled = () => config.ENABLE_WEBSOCKETS;

  return (
    <>
      <Show when={props.active()}>
        <div
          class="live-performance-poll-status"
          role="status"
          aria-live="polite"
          aria-label="Updating live performance data"
        >
          <FiRefreshCw class="live-performance-poll-status__icon" size={14} aria-hidden="true" />
          <span class="live-performance-poll-status__label">Updating</span>
        </div>
      </Show>
      <Show when={!props.active() && websocketsEnabled() && props.connected()}>
        <div
          class="live-performance-poll-status live-performance-poll-status--live"
          role="status"
          aria-live="polite"
        >
          <span class="live-performance-poll-status__label">Live updates</span>
        </div>
      </Show>
      <Show when={!props.active() && websocketsEnabled() && !props.connected()}>
        <div
          class="live-performance-poll-status live-performance-poll-status--idle"
          role="status"
          aria-live="polite"
        >
          <span class="live-performance-poll-status__label">Waiting for stream</span>
        </div>
      </Show>
      <Show when={!websocketsEnabled() && props.connected()}>
        <div
          class="live-performance-poll-status live-performance-poll-status--live"
          role="status"
          aria-live="polite"
        >
          <span class="live-performance-poll-status__label">Polling live data</span>
        </div>
      </Show>
      <Show when={!websocketsEnabled() && !props.connected()}>
        <div class="live-performance-poll-status live-performance-poll-status--idle" role="status">
          <span class="live-performance-poll-status__label">Live updates off</span>
        </div>
      </Show>
    </>
  );
}
